'use client';

import classNames from '@sindresorhus/class-names';
import {COOKIE_WEB_AUTO_DOWNLOAD, setCookie} from '@utils/cookies';
import Link from 'next/link';

import {AnalyticsLink} from '@web-landing/analytics/components/AnalyticsLink';
import {log} from '@web-landing/components/MiniPicks/analytics';
import {useOmicron} from '@web-landing/components/OmicronClientContext';
import {Search} from '@web-landing/components/SearchBlock/Search/Search';
import {SwitchLanguageComponent} from '@web-landing/components/SwitchLanguageComponent/SwitchLanguageComponent';

import {useIsMobile} from '@web-landing/hooks/useIsMobile';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import {EVENTS} from '@web-landing/analytics/events';

import {ym_log} from './analytics';
import styles from './RightSideContent.module.scss';

export const SearchWithDownload = ({
  isTopScroll,
  requestUrl,
  cookieDomain,
  searchButtonText,
  downloadButtonText,
}: {
  isTopScroll: boolean;
  requestUrl?: string;
  cookieDomain?: string;
  searchButtonText?: string;
  downloadButtonText?: string;
}) => {
  const isMobile = useIsMobile();
  const omicron = useOmicron();

  const showSearch = omicron && omicron.config.WEB_SHOW_SEARCH;
  const showLocales = omicron && omicron.config.WEB_SHOW_LOCALIZATION;

  const openStoreClick = () => {
    log.omicronFromLandingToInstructions();
    ym_log.headerMenuButtonDownloadYM();

    if (isMobile) {
      setCookie(COOKIE_WEB_AUTO_DOWNLOAD, 'true', cookieDomain || '');
    }
  };

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.mobileHide]: isTopScroll,
      })}
    >
      <SwitchLanguageComponent
        showLocalization={showLocales}
        location="header"
      />
      {showSearch && requestUrl && (
        <Search
          requestUrl={requestUrl}
          searchButtonText={searchButtonText}
          testId={'header_search_button'}
        />
      )}
      <AnalyticsLink
        local
        event={EVENTS.downloadRustoreTopClick}
        className={classNames(styles.downloadButton, {
          [styles.scrollDownloadButton]: !isTopScroll,
        })}
        href="/instruction"
        onClick={openStoreClick}
      >
        {downloadButtonText}
      </AnalyticsLink>
    </div>
  );
};

export const MediaKitButton = ({
  isTopScroll,
  href,
}: {
  isTopScroll: boolean;
  href?: string;
}) => {
  return (
    <Link
      className={classNames(styles.mediaKitButton, {
        [styles.scrollDownloadButton]: !isTopScroll,
      })}
      href={href as string}
      onClick={() =>
        logTmrEvent(EVENTS.mediaKitHeaderClick, {button_text: 'Скачать гайд'})
      }
    >
      Скачать гайд&nbsp;<span className={styles.desktopText}>по логотипу</span>
    </Link>
  );
};
